// extracted by mini-css-extract-plugin
export default {"touch-article-topad":"touch-article-topad--KFIPF"};